import {
  LEAGUE_DEFS,
  equilibriumPace,
  statsToParams,
  sustainableTapRate,
  theoreticalBestTime,
} from '../sim/race/params';
import { RACE_TUNING, type RaceTuning } from '../sim/race/tuning';
import { el } from './dom';

/**
 * ?debug tuning surface: edits RACE_TUNING in place. Races snapshot their
 * parameters at setup, so a change lands on the NEXT race — the running
 * one stays deterministic.
 */
export function mountTuningPanel(root: HTMLElement): void {
  const leagueTable = el('div', { class: 'tuning-leagues' });

  const refreshLeagues = (): void => {
    leagueTable.textContent = '';
    for (const def of LEAGUE_DEFS) {
      const params = statsToParams({
        speed: def.medianLevel,
        stamina: def.medianLevel,
        accel: def.medianLevel,
        heart: def.medianLevel,
      });
      leagueTable.append(
        el(
          'div',
          { class: 'tuning-league-row' },
          el('span', {}, `${def.name} L${def.medianLevel}`),
          el('span', {}, `${sustainableTapRate(params).toFixed(2)}/s`),
          el('span', {}, `${equilibriumPace(params).toFixed(1)} m/s`),
          el('span', {}, `${theoreticalBestTime(params, def.distanceM).toFixed(1)}s best`),
        ),
      );
    }
  };

  const fields = (Object.keys(RACE_TUNING) as (keyof RaceTuning)[]).map((key) => {
    const value = RACE_TUNING[key];
    const input = el('input', {
      type: 'number',
      step: Math.abs(value) >= 10 ? '1' : '0.05',
      value: String(value),
      onchange: (event) => {
        const raw = Number((event.target as HTMLInputElement).value);
        if (Number.isFinite(raw)) {
          RACE_TUNING[key] = raw;
          refreshLeagues();
        }
      },
    });
    return el('label', { class: 'tuning-row' }, el('span', {}, key), input);
  });

  const body = el(
    'div',
    { class: 'tuning-body' },
    el('div', { class: 'tuning-note' }, 'Applies to the next race.'),
    ...fields,
    leagueTable,
  );

  const toggle = el('button', { class: 'button tuning-toggle' }, 'Tuning');
  toggle.addEventListener('click', () => {
    body.classList.toggle('open');
  });

  refreshLeagues();
  root.append(el('div', { class: 'tuning-panel interactive' }, toggle, body));
}
